import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const totalRank = useSelector((state) => state.brandLeaderboard.totals?.total_ranking);
  const isUserQa = useSelector((state) => state.brandLeaderboard.currentUser.isUserQa);
  const previous_ranking = useSelector((state) => state.brandLeaderboard.totals?.previous_ranking);
  const displayTotals = useSelector((state) => state.brandLeaderboard.totals?.display_totals);

  return (
    <div className="data-display-container">
      {(totalRank || totalRank === 0) && displayTotals ? (
        <DataDisplay label="Total Ranking" value={totalRank} disableAnimation={isUserQa} />
      ) : null}
      {(previous_ranking || previous_ranking === 0) && displayTotals ? (
        <DataDisplay
          label="Previous Ranking"
          value={previous_ranking}
          disableAnimation={isUserQa}
        />
      ) : null}
    </div>
  );
});
